
import adminRoutes from "../routes/adminRoutes";
import coachRoutes from "../routes/coachRoutes";
import studentRoutes from "../routes/studentRoutes";
import publicRoutes from "../routes/publicRoutes";

/**
 * Centralized role constants
 * Prevents typos and improves maintainability
 */
export const ROLES = {
  SUPER_ADMIN: "super admin",
  ADMIN: "admin",
  COACH: "coach",
  INSTRUCTOR: "instructor",
  STUDENT: "student",
  PUBLIC: "public user",
};


/**
 * Role-based route configuration
 */
const ROLE_ROUTE_MAP = {
   [ROLES.SUPER_ADMIN]: {
    prefix: "/admin",
    routes: adminRoutes,
    allowedRoles: [ROLES.SUPER_ADMIN],
  },
  [ROLES.ADMIN]: {
    prefix: "/admin",
    routes: adminRoutes,
    allowedRoles: [ROLES.ADMIN],
  },

  [ROLES.COACH]: {
    prefix: "/coach",
    routes: coachRoutes,
    allowedRoles: [ROLES.COACH],
  },

  [ROLES.INSTRUCTOR]: {
    prefix: "/coach",
    routes: coachRoutes,
    allowedRoles: [ROLES.COACH, ROLES.INSTRUCTOR],
  },

  [ROLES.STUDENT]: {
    prefix: "/student",
    routes: studentRoutes,
    allowedRoles: [ROLES.STUDENT],
  },

  [ROLES.PUBLIC]: {
    prefix: "/student",
    routes: studentRoutes,
    allowedRoles: [ROLES.PUBLIC],
  },
};

/**
 * Returns accessible routes based on role
 * @param {string} role - Role from Redux / API
 */
export const getRoutesByRole = (role) => {
  const normalizedRole = role?.toLowerCase().trim();
  const config = ROLE_ROUTE_MAP[normalizedRole];

  if (!config) {
    return publicRoutes;
  }

  const { prefix, routes, allowedRoles } = config;

  return routes.map(route => ({
    ...route,
    path: `${prefix}/${route.path}`,
    allowedRoles,
  }));
};

/**
 * Default landing page after login
 * @param {string} role
 */
export const getDefaultRouteByRole = (role) => {
  const normalizedRole = role?.toLowerCase().trim();

  switch (normalizedRole) {
    case "super admin":
    case "admin":
      return "/admin/dashboard1"; // 👈 IMPORTANT: match your real admin route

    case "coach":
    case "instructor":
      return "/coach/dashboard";

    case "student":
      return "/student/dashboard";

    case "public user":
      return "/";

    default:
      return "/";
  }
};




// import adminRoutes from "../routes/adminRoutes";
// import coachRoutes from "../routes/coachRoutes";
// import studentRoutes from "../routes/studentRoutes";
// import publicRoutes from "../routes/publicRoutes";

// // export const getRoutesByRole = (group_id) => {
// //   switch (group_id) {
// //     case 1: 
// //       return adminRoutes.map(r => ({ ...r, path: "/admin/" + r.path }));
// //     case 2: 
// //       return coachRoutes.map(r => ({ ...r, path: "/coach/" + r.path }));
// //     case 3: 
// //       return studentRoutes.map(r => ({ ...r, path: "/student/" + r.path }));
// //     default:
// //       return publicRoutes;
// //   }
// // };

// // export const getRoutesByRole = (group_id) => {
// //   switch (group_id) {
// //     case 1:
// //       return adminRoutes.map(r => ({
// //         ...r,
// //         path: "/admin/" + r.path,
// //         allowedRoles: [1],
// //       }));
// //     case 2:
// //       return coachRoutes.map(r => ({
// //         ...r,
// //         path: "/coach/" + r.path,
// //         allowedRoles: [2],
// //       }));
// //     case 3:
// //       return studentRoutes.map(r => ({
// //         ...r,
// //         path: "/student/" + r.path,
// //         allowedRoles: [3],
// //       }));
// //     default:
// //       return publicRoutes;
// //   }
// // };

// /**
//  * Generates the accessible routes based on the role string.
//  * @param {string} role - The role from Redux (e.g., "Public User", "Admin")
//  */
// export const getRoutesByRole = (role) => {
//   // Normalize role for consistent matching
//   const normalizedRole = role?.toLowerCase().trim();

//   switch (normalizedRole) {
//     case "admin":
//       return adminRoutes.map(r => ({
//         ...r,
//         path: "/admin/" + r.path,
//         allowedRoles: ["admin"],
//       }));

//     case "coach":
//       return coachRoutes.map(r => ({
//         ...r,
//         path: "/coach/" + r.path,
//         allowedRoles: ["coach"],
//       }));

//     case "student":
//     case "public user":
//       return studentRoutes.map(r => ({
//         ...r,
//         path: "/student/" + r.path,
//         allowedRoles: ["student", "public user"],
//       }));

//     default:
//       // Includes Login, Register, Landing Page, etc.
//       return publicRoutes;
//   }
// };

// /**
//  * Determines the initial landing page after login based on the user's role string.
//  * @param {string} role - The role name from the API response (e.g., 'Public User')
//  */
// export const getDefaultRouteByRole = (role) => {
//   // Normalize the role to lowercase to avoid case-sensitivity issues
//   const normalizedRole = role?.toLowerCase().trim();

//   switch (normalizedRole) {
//     case "admin":
//       return "/admin/dashboard";

//     case "coach":
//     case "instructor":
//       return "/coach/dashboard";

//     case "student":
//     case "public user": // Mapping your Redux role here
//       return "/student/dashboard";

//     default:
//       return "/";
//   }
// };

// // export const getDefaultRouteByRole = (group_id) => {
// //   switch (group_id) {
// //     case 1: return "/admin/dashboard";
// //     case 2: return "/coach/dashboard";
// //     case 3: return "/student/dashboard";
// //     default: return "/";
// //   }
// // };

